import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface Props {
  workspaceId: string;
  onClick: (workspaceId: string) => void;
}

export const CurrentWorkspaceSelectAction = observer((props: Props): ReactElement => {
  const { t } = useTranslator();

  const handleClick = (): void => {
    props.onClick(props.workspaceId);
  };

  return (
    <IconButton
      color='primary'
      size='sm'
      onClick={handleClick}
      title={t('select')}
    >
      <FontAwesomeIcon icon={faCheck} />
    </IconButton>
  );
});
